var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["type", "button", "class", "btn btn-primary btn-xs"]
var __target

module.exports = function description (model, root) {
  elementOpen("button", "e25eb839-4b07-404d-a482-d861eb78c85d", hoisted1, "onclick", function ($event) {
    var $element = this;
  root.currentItem = model.keys.addKey()})
    text("Add key")
  elementClose("button")
}
